import { Component, OnInit } from '@angular/core';
import {UrlEntryService} from "../../../core/urlEntry/url-entry.service";

@Component({
  selector: 'app-url-entry-debug',
  templateUrl: './url-entry.component.html',
  styleUrls: ['./url-entry.component.scss']
})
export class UrlEntryComponent implements OnInit {

  constructor(
      public urlEntryService: UrlEntryService,
  ) { }

  ngOnInit(): void {

  }

}
